import { TruckAlertOutlineIcon } from './TruckAlertOutlineIcon';

/**
 * author: Simran
 * id FCE10225-CA09-4B2E-8BE3-5B9D718B13D5
 * name truck-alert-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-alert-outline.svg
 * tags
 * - Transportation + Road 
 * - Alert / Error 
 */
export const TruckErrorOutlineIcon = TruckAlertOutlineIcon;
export default TruckErrorOutlineIcon